/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatIBAssetsUrl } from '@whitbread-eos/utils/server';
import React, { useState, useEffect } from 'react';
import { LocationInput } from './LocationInput/index';
import { LocationResults } from './LocationResults/index';
const Location = ({ labels, location, setLocation, setSelectedLocation, selectedLocation, icons, mobile = false, globalLabels, hideEditSearch = ()=>{
    return;
}, onOpenChange, showError, setShowError })=>{
    const [isInputBlured, setIsInputBlured] = useState(true);
    const handleLocationChange = (value)=>{
        setIsInputBlured(false);
        setLocation(value);
        if (!value) {
            setShowError(false);
        }
    };
    const handleInputBlur = ()=>{
        if (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.suggestion) {
            setLocation(selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.suggestion);
        }
        setIsInputBlured(true);
    };
    const handleInputFocus = ()=>{
        setIsInputBlured(false);
    };
    const handleResultsFound = (resultsFound)=>{
        setShowError(!resultsFound);
    };
    useEffect(()=>{
        if (showError) {
            hideEditSearch();
        }
    }, [
        showError
    ]);
    var _labels_where;
    return /*#__PURE__*/ _jsxs("div", {
        className: firstRowStyle,
        "data-testid": mobile ? 'IB-Search-Container-Mobile-Location' : 'IB-Search-Container-Desktop-Location',
        children: [
            /*#__PURE__*/ _jsx(LocationInput, {
                location: location,
                onChange: handleLocationChange,
                locationIcon: formatIBAssetsUrl(labels === null || labels === void 0 ? void 0 : labels.whereIcon),
                placeholder: (_labels_where = labels === null || labels === void 0 ? void 0 : labels.where) !== null && _labels_where !== void 0 ? _labels_where : '',
                clearIcon: formatIBAssetsUrl(labels === null || labels === void 0 ? void 0 : labels.whereDismissIcon),
                onBlur: handleInputBlur,
                onFocus: handleInputFocus,
                errorIcon: formatIBAssetsUrl(icons['icon.notification.error']),
                showError: showError
            }),
            /*#__PURE__*/ _jsx(LocationResults, {
                location: location,
                setLocation: setLocation,
                labels: labels,
                isInputBlured: isInputBlured,
                selectedLocation: selectedLocation,
                setSelectedLocation: setSelectedLocation,
                onResultsFound: handleResultsFound,
                mobile: mobile,
                globalLabels: globalLabels,
                onOpenChange: (open)=>onOpenChange(open)
            })
        ]
    });
};
export default Location;
const firstRowStyle = 'grow-[4] mobile:w-full';
